import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { UserProfileResponse } from "../models/response/userProfileResponse";

export interface UserState {
  data: UserProfileResponse | null;
  loading: boolean;
  error: string | null;
}

const initialState: UserState = {
  data: null,
  loading: false,
  error: null,
};

const userSlice = createSlice({
  name: "userProfile",
  initialState,
  reducers: {
    fetchProfile: (state) => {
      state.loading = true;
      state.error = null;
    },
    profileFetched: (
      state,
      action: PayloadAction<UserProfileResponse | undefined>
    ) => {
      state.data = action.payload ?? null;
      state.loading = false;
    },
    fetchProfileFailure: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
    },

    markReadAllInboxMessages: (state) => {
      state.data!.inboxUnreadCount = 0;
    },

    markReadInboxMessage: (state) => {
      state.data!.inboxUnreadCount = state.data!.inboxUnreadCount - 1;
    },

    increaseInboxUnreadCount: (state) => {
      state.data!.inboxUnreadCount = state.data!.inboxUnreadCount + 1;
    },

    mobileOtpVerified: (state, action: PayloadAction<boolean>) => {
      state.data!.mobileVerified = action.payload;
    },

    emailOtpVerified: (state, action: PayloadAction<boolean>) => {
      state.data!.emailVerified = action.payload;
    },

    mobileOtpVerifiedFailure: (state, action: PayloadAction<string>) => {
      state.error = action.payload;
    },

    updatePasswordChangeOneClick: (state, action: PayloadAction<boolean>) => {
      state.data!.isOneTimePasswordChanged = action.payload;
    },

    updateUserLanguage: (state, action: PayloadAction<string>) => {
      state.data!.languageCode = action.payload;
    },

    updateUserIsOneTimePasswordChanged: (state, action: PayloadAction<boolean>) => {
      state.data!.isOneTimePasswordChanged = action.payload;
    },
  },
});

export const {
  fetchProfile,
  profileFetched,
  fetchProfileFailure,
  mobileOtpVerified,
  mobileOtpVerifiedFailure,
  emailOtpVerified,
  markReadAllInboxMessages,
  markReadInboxMessage,
  increaseInboxUnreadCount,
  updatePasswordChangeOneClick,
  updateUserLanguage,
  updateUserIsOneTimePasswordChanged,
} = userSlice.actions;

export default userSlice.reducer;
